<!--<div>{{ options.chartHeader }}</div>-->


<ng-container *ngIf="resultsObserable | async as results; else loading;">
  <ng-container *ngIf="results && results.results.length > 0">

    <div class="test">
      <!--[showDataLabel]="true"-->
      <ngx-charts-bar-vertical-stacked style="padding:1px"
                                       [view]="view | async"
                                       [scheme]="scheme"
                                       [results]="results.resultsPage"
                                       [barmaxwidth]="25"
                                       [xAxis]="showXAxis"
                                       [yAxis]="showYAxis"
                                       [legend]="showLegend"
                                       [legendTitle]="legendTitle"
                                       [showXAxisLabel]="showXAxisLabel"
                                       [showYAxisLabel]="showYAxisLabel"
                                       [xAxisLabel]="options.xAxisLabel"
                                       [yAxisLabel]="options.yAxisLabel"
                                       [animations]="animations"
                                       (select)="onSelect($event)">

        <ng-template *ngIf="eveTooltipTemplate != null" #tooltipTemplate let-model="model">
          <ng-container *ngTemplateOutlet="eveTooltipTemplate;context:{model}"></ng-container>
        </ng-template>

      </ngx-charts-bar-vertical-stacked>
    </div>

    <div class="test">
      <mat-paginator [length]="results.results.length " [pageSize]="10" [pageSizeOptions]="[10,20,30,40,50,60,70,80,90,100]"></mat-paginator>
    </div>
    <div [innerHTML]="legendStyles | async">
    </div>

  </ng-container>
  <ng-container *ngIf="results != null && results.results.length == 0">
    <div style="margin-top: 135px;">
      <div style="opacity: 0.2; color:gray;"><img src="{{reportingUrl}}/Images/eveLogo.png" alt="eve Logo" /></div>
      <div style="color: #646965; text-align: center">no results found</div>
    </div>
  </ng-container>




</ng-container>
<ng-template #loading>
  <span class="fa fa-spinner fa-pulse fa-5x" style="opacity: 1; color:gray;"></span>
</ng-template>






